import { useCustomerPageContext } from "@contexts/customer"
import Box from "@mui/material/Box"
import Divider from "@mui/material/Divider"
import Stack from "@mui/material/Stack"
import Typography from "@mui/material/Typography"
import { CouponValueType } from "__generated__/graphql"
import { useMemo } from "react"

export default function CurrentPlan() {
  const { translate, currentCustomer: customer } = useCustomerPageContext()

  const addOnUser = useMemo(() => {
    return customer?.package?.addOns.find((addOn) => addOn.name === "User")
  }, [customer?.package?.addOns])

  const discountText = useMemo(() => {
    const coupon = customer?.package?.couponCode
    if (!coupon) return ""

    if (coupon.valueType === CouponValueType.Amount) {
      return `($${coupon.value} off coupon code discount applied)`
    }

    if (coupon.valueType === CouponValueType.Percent) {
      return `(%${coupon.value} off coupon code discount applied)`
    }

    return ""
  }, [customer?.package?.couponCode])

  console.log("see, discountText: ", discountText)
  console.log("customer: ", customer)

  const totalCost =
    customer?.package?.price *
      ((addOnUser?.quantity || 0) +
        (customer?.package?.limits?.cPerson || 0)) || 0

  function formatDate(isoDate: string | undefined): string {
    if (!isoDate) return ""
    const date = new Date(isoDate)
    const year = date.getFullYear()
    const month = (date.getMonth() + 1).toString().padStart(2, "0")
    const day = date.getDate().toString().padStart(2, "0")
    return `${day}.${month}.${year}`
  }
  return (
    <Box sx={{ width: "100%" }}>
      <Typography>{translate("current_plan")}</Typography>
      <Stack
        sx={{
          border: "1px #c9c9c9 solid",
          borderRadius: 1.5,
          height: "100%"
        }}
        justifyContent={"space-evenly"}
        gap={1}
      >
        <CurrentPlanContent
          text={translate("current_plan")}
          value={customer?.package?.name || ""}
          valueLink={true}
          pt={1}
        />
        <Divider />
        <CurrentPlanContent
          text={translate("period")}
          value={translate(customer?.package?.periodMode || "")}
        />
        <Divider />
        <CurrentPlanContent
          text={translate("cost")}
          value={`$${totalCost}`}
          valueSupplement={
            discountText ? (
              <Typography component="span" sx={{ color: "#2e7d32", ml: 0.5 }}>
                {discountText}
              </Typography>
            ) : null
          }
        />
        <Divider />
        <CurrentPlanContent
          text={translate("next_billing_date")}
          value={formatDate(customer?.package?.endDate as string)}
          pb={1}
        />
      </Stack>
    </Box>
  )
}

function CurrentPlanContent({
  text,
  value,
  valueSupplement,
  pt,
  pb,
  valueLink
}: {
  text: string
  value: string | number
  valueSupplement?: React.ReactNode
  pt?: number
  pb?: number
  valueLink?: boolean
}) {
  return (
    <Stack
      pt={pt}
      pb={pb}
      px={1}
      direction={"row"}
      justifyContent={"space-between"}
    >
      <Typography>{text}</Typography>
      <Typography
        component="div"
        sx={{
          color: valueLink ? "#147BFB" : "black",
          fontWeight: valueLink ? "bold" : "normal"
        }}
      >
        {value}
        {valueSupplement}
      </Typography>
    </Stack>
  )
}
